import React from 'react';
import { Stack, Icon, P, IconButton } from '@fashionnovateam/nova-ui-toolkit';
import { useHistory, useLocation } from 'react-router-dom';

export type PurchaseOrderNotFoundProps = {
  purchaseOrderId: string;
  error: unknown;
};

export function PurchaseOrderNotFound(props: PurchaseOrderNotFoundProps) {
  const history = useHistory();
  const { pathname } = useLocation();
  const { purchaseOrderId } = props;
  return (
    <>
      <Stack direction="row" gap="md" align="start">
        <IconButton
          icon={<Icon name="chevron-left" />}
          label="Back"
          color="secondary"
          size="sm"
          className="m-4"
          onClick={() =>
            history.push(pathname.substring(0, pathname.lastIndexOf('/')))
          }
        />
      </Stack>
      <Stack
        direction="col"
        content="center"
        gap="md"
        className="w-full h-full"
      >
        <Icon.FileSearch
          variant="solid"
          className="text-3xl text-primary-700"
        />
        <Stack direction="col" gap="sm" align="center">
          <P size="3xl" color="primary" weight="medium">
            Oops! The purchase order{' '}
            {purchaseOrderId || 'you are trying to find'} was not found.
          </P>
          <P size="md" color="secondary" weight="normal">
            Sorry, we couldn&apos;t find the page you where looking for.
          </P>
        </Stack>
      </Stack>
    </>
  );
}
